import { render, staticRenderFns } from "./my-client-infos.vue?vue&type=template&id=bcb45be2&scoped=true"
import script from "./my-client-infos.vue?vue&type=script&lang=js"
export * from "./my-client-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb45be2",
  null
  
)

export default component.exports